import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ArrowRight, RefreshCw } from 'lucide-react';
export const Hero: React.FC = () => {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-231">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 items-center" data-id="element-232">
        <motion.div className="relative z-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-233">
          <h1 className="font-display text-6xl md:text-7xl lg:text-8xl leading-[1.05] text-primary mb-6 tracking-tight" data-id="element-234">
            Packaging,
            <br data-id="element-235" />
            on a loop.
          </h1>
          <p className="text-lg md:text-xl text-ink/70 mb-10 max-w-lg leading-relaxed" data-id="element-236">
            We own the bottles, crates, and pallets. You lease them when you
            need them and send them back when you're done. No buying packaging
            by the truckload, no warehouse full of empties to deal with.
          </p>

          <div className="flex flex-wrap items-center gap-4 mb-16" data-id="element-237">
            <Button variant="primary" size="lg" data-id="element-238">
              Request a demo <ArrowRight className="ml-2 w-5 h-5" data-id="element-239" />
            </Button>
            <Button variant="outline" size="lg" data-id="element-240">
              Explore the tech
            </Button>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 pt-8 border-t border-primary/10" data-id="element-241">
            <div data-id="element-242">
              <p className="font-mono text-2xl text-primary font-medium mb-1" data-id="element-243">
                2.4M+
              </p>
              <p className="text-sm text-muted" data-id="element-244">Cycles tracked</p>
            </div>
            <div data-id="element-245">
              <p className="font-mono text-2xl text-primary font-medium mb-1" data-id="element-246">
                87%
              </p>
              <p className="text-sm text-muted" data-id="element-247">Lower CO₂ per cycle</p>
            </div>
            <div className="hidden md:block" data-id="element-248">
              <p className="font-mono text-2xl text-primary font-medium mb-1" data-id="element-249">
                120+
              </p>
              <p className="text-sm text-muted" data-id="element-250">Industry partners</p>
            </div>
          </div>
        </motion.div>

        <div className="relative h-[400px] lg:h-[600px] flex items-center justify-center" data-id="element-251">
          {/* Glossy mint backdrop blob */}
          <div className="absolute inset-0 bg-mint rounded-full blur-3xl opacity-60 scale-75" data-id="element-252" />

          {/* Abstract Loop Animation */}
          <motion.div className="absolute inset-0 flex items-center justify-center opacity-30" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 0.3,
          scale: 1
        }} transition={{
          duration: 1.5,
          ease: 'easeOut'
        }} data-id="element-253">
            <svg viewBox="0 0 400 400" className="w-full h-full max-w-[500px] animate-spin-slow" data-id="element-254">
              <circle cx="200" cy="200" r="180" fill="none" stroke="var(--color-leaf)" strokeWidth="1" strokeDasharray="4 8" data-id="element-255" />
              <circle cx="200" cy="200" r="140" fill="none" stroke="var(--color-primary)" strokeWidth="2" data-id="element-256" />
              <circle cx="200" cy="200" r="100" fill="none" stroke="var(--color-leaf)" strokeWidth="1" strokeDasharray="2 4" data-id="element-257" />
            </svg>
          </motion.div>

          <motion.div className="relative z-10 w-64 h-64 md:w-80 md:h-80 rounded-full border border-primary/10 flex items-center justify-center bg-white shadow-glossy-lg gloss-card" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} data-id="element-258">
            <div className="absolute inset-4 rounded-full border border-leaf/20 animate-spin-reverse-slow" data-id="element-259" />
            <div className="text-center relative z-10" data-id="element-260">
              <RefreshCw className="w-12 h-12 text-leaf mx-auto mb-4" data-id="element-261" />
              <p className="font-display text-2xl text-primary" data-id="element-262">Zero Waste</p>
              <p className="font-mono text-xs text-muted mt-2" data-id="element-263">ID: CYB-001</p>
            </div>

            {/* Orbiting Bottle Node */}
            <motion.div className="absolute w-4 h-4 bg-leaf rounded-full shadow-leaf-glow" animate={{
            rotate: 360
          }} transition={{
            duration: 8,
            repeat: Infinity,
            ease: 'linear'
          }} style={{
            top: '50%',
            left: '50%',
            marginTop: '-8px',
            marginLeft: '-8px',
            originX: '0px',
            originY: '0px'
          }} data-id="element-264">
              <div className="absolute -top-16 -left-2 w-8 h-8 flex items-center justify-center" style={{
              transform: 'translateY(-140px)'
            }} data-id="element-265">
                <div className="w-3 h-8 bg-primary rounded-sm relative" data-id="element-266">
                  <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-1.5 h-2 bg-primary rounded-t-sm" data-id="element-267" />
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
};